<template>
    <div class="pageManager-m">
        <div class="jobMain">
            <div class="manager-rig">
                <div class="manager-rt" style="padding-bottom: 0;">
                    <div class="manager-rtle">成绩维护</div>
                    <div class="manager-rtr">
                        <el-button size="medium" @click="downloadImportTemplate" :loading="templateLoading">
                            <i class="el-icon-download"></i> 下载导入模板
                        </el-button>
                        <el-button size="medium" type="primary" plain @click="triggerImportFile">
                            <i class="el-icon-upload2"></i> 导入 Excel
                        </el-button>
                        <input
                            ref="importFileInput"
                            type="file"
                            accept=".xlsx,.xls"
                            style="display: none;"
                            @change="onImportFileChange"
                        />
                        <el-button class="manager-rtr-export" size="medium" @click="exportScoredExcel" :loading="exportLoading">
                            <i class="el-icon-download"></i> 导出数据
                        </el-button>
                    </div>
                </div>
                <div class="manager-rsubtle">为待录入考生批量维护各科成绩，支持 Excel 模板下载、导入与导出</div>
                <div class="exam-m1">
                    <el-row :gutter="24">
                        <el-col :span="6" v-for="(item,index) in boxList" :key="index">
                            <div class="exam-m1-box">
                                <div class="exam-m1-icon" :class="item.css"><i :class="item.icon"></i></div>
                                <div class="exam-m1-box-tle">{{ item.label }}</div>
                                <div class="exam-m1-box-num" :class="boxCss[index]">{{ item.num }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="exam-m2">
                    <div class="exam-m2-t">
                        <div class="exam-tab">
                            <ul>
                                <li v-for="(item,index) in tabs.tabList" :class="tabs.curTab===index ? 'active' : ''" :key="index" @click="tabClink(index)">{{ item.label }}({{ item.num }})</li>
                            </ul>
                        </div>
                        <div class="exam-tr">
                            <el-input v-model="gradeSearch" prefix-icon="el-icon-search" placeholder="搜索姓名" @input="getGrade"></el-input>
                        </div>
                    </div>
                    <div>
                        <table class="manager-exam-table">
                            <tr>
                                <th>序号</th>
                                <th>姓名</th>
                                <th>准考证号</th>
                                <th>专业</th>
                                <th>总分</th>
                            </tr>
                            <tbody v-for="(item,index) in students" :key="index">
                                <tr>
                                    <td>{{index+1}}</td>
                                    <td>
                                        <div class="exam-td-name">{{item.applicantName}}</div>
                                        <div class="exam-td-icard">{{item.idCardNumber}}</div>
                                    </td>
                                    <td>{{item.ticketNumber}}</td>
                                    <td>{{item.positionName}}</td>
                                    <td>
                                        <el-button v-if="item.statusScore === 0" type="primary" round size="mini" @click="saveScore(item.id,index)">保存分数</el-button>
                                        <span v-else>{{item.totalScore || ''}}</span>
                                    </td>
                                </tr>
                                <tr v-if="item.statusScore === 0">
                                    <td colspan="5" style="background: #FAFAFA;">
                                        <el-row :gutter="16">
                                            <el-col :span="8" v-for="(v,i) in item.examScheduleList" :key="i">
                                                <el-input type="number" placeholder="请输入考生该科目分数" v-model="v.score" size="mini">
                                                    <template slot="prepend">{{ v.examSubject }}</template>
                                                </el-input>
                                            </el-col>
                                        </el-row>
                                    </td>
                                </tr>
                                <tr v-if="item.statusScore === 1">
                                    <td colspan="5" style="background: #FAFAFA;">
                                        <el-row :gutter="16">
                                            <el-col :span="8" v-for="(v,i) in item.examScheduleList" :key="i">{{ v.examSubject }}：{{ v.score }}</el-col>
                                        </el-row>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="成绩导入预览确认"
            :visible.sync="importPreviewVisible"
            width="92%"
            top="4vh"
            custom-class="import-preview-dialog"
            @closed="resetImportPreview"
        >
            <div v-if="importParseErrors.length" class="import-error-box">
                <div class="import-error-title"><i class="el-icon-warning-outline"></i> 以下问题需修正后再导入：</div>
                <ul>
                    <li v-for="(err, idx) in importParseErrors" :key="'err-' + idx">{{ err }}</li>
                </ul>
            </div>
            <div v-else class="import-preview-wrap">
                <div class="import-preview-summary">
                    <span class="import-preview-summary-num">{{ importPreviewList.length }}</span>
                    <span>名考生待导入，请逐条核对各科分数</span>
                </div>
                <div class="import-preview-list">
                    <div
                        v-for="(item, index) in importPreviewList"
                        :key="item.examAssignmentId || index"
                        class="import-preview-card"
                    >
                        <div class="import-preview-card-head">
                            <div class="import-preview-index">{{ index + 1 }}</div>
                            <div class="import-preview-main">
                                <div class="import-preview-name-row">
                                    <span class="import-preview-name">{{ item.applicantName || '—' }}</span>
                                    <span class="import-preview-id">分配ID {{ item.examAssignmentId }}</span>
                                </div>
                                <div class="import-preview-idcard">{{ item.idCardNumber || '—' }}</div>
                                <div class="import-preview-major">{{ item.positionName || '—' }}</div>
                                <div class="import-preview-ticket">准考证号：{{ item.ticketNumber || '—' }}</div>
                            </div>
                            <div class="import-preview-total">
                                <span class="label">合计总分</span>
                                <span class="value">{{ calcPreviewTotal(item) }}</span>
                            </div>
                        </div>
                        <div class="import-preview-subjects">
                            <div class="import-preview-subjects-title">
                                各科分数
                                <el-tag size="mini" type="warning">{{ (item.scoresList || []).length }} 门</el-tag>
                            </div>
                            <div
                                v-for="(subject, sIdx) in item.scoresList"
                                :key="sIdx"
                                class="import-preview-subject-row"
                            >
                                <span class="import-subject-index">{{ sIdx + 1 }}</span>
                                <span class="import-subject-name">{{ subject.examSubject || '—' }}</span>
                                <span class="import-subject-score"><i class="el-icon-edit-outline"></i> {{ subject.score }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="importPreviewVisible = false">取消</el-button>
                <el-button
                    type="primary"
                    :disabled="importParseErrors.length > 0 || !importPayload.length"
                    :loading="importSubmitting"
                    @click="confirmImport"
                >确认导入（{{ importPreviewList.length }} 人）</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import {
    downloadScoreImportTemplate,
    downloadScoredExport,
    parseScoreImportWorkbook,
    readScoreImportFile,
} from '../utils/scoreImport';

export default {
    name: 'PageManagerGrade',
    data() {
        return {
            boxList: [
                {label:'总考生数', num: 0, icon: 'el-icon-user', css: 'exam-m1-icon-blue'},
                {label: '已录入', num: 0, icon: 'el-icon-finished', css: 'exam-m1-icon-green'},
                {label: '待录入', num: 0, icon: 'el-icon-warning-outline', css: 'exam-m1-icon-yellow'},
                {label: '平均分', num: 0, icon: 'el-icon-data-line', css: 'exam-m1-icon-purple'},
            ],
            boxCss: {0: '', 1: 'green', 2: 'yellow'},
            tabs: {
                tabList: [
                    {label: '待录入', num: 0},
                    {label: '已录入', num: 0},
                    {label: '全部', num: 0}
                ],
                curTab: 0,
                queryStatus: '',
            },
            gradeSearch: '',
            students: [],
            examStatus: {0: '待录入', 1: '已录入'},
            pendingStudents: [],
            templateLoading: false,
            exportLoading: false,
            importPreviewVisible: false,
            importPreviewList: [],
            importPayload: [],
            importParseErrors: [],
            importSubmitting: false,
        }
    },
    mounted() {
        document.title = '潞安招聘-成绩维护';
        this.getCounts();
        this.getGrade();
    },
    methods: {
        tabClink: function (n) {
            this.tabs.curTab = n;
            if(n === 2) {
                this.tabs.queryStatus = '';
            } else {
                this.tabs.queryStatus = n;
            }
            this.getGrade();
        },
        getCounts: function () {
            axios.get('/zhaopinapi/exam-assignment/status-counts/score', {
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.boxList[0].num = _d.data[0].total_users || 0;
                    this.boxList[1].num = _d.data[0].status_score_one_count || 0;
                    this.boxList[2].num = _d.data[0].status_score_zero_count || 0;
                    this.boxList[3].num = _d.data[0].average_score || 0;

                    this.tabs.tabList[0].num = _d.data[0].status_score_zero_count || 0;
                    this.tabs.tabList[1].num = _d.data[0].status_score_one_count || 0;
                    this.tabs.tabList[2].num = (_d.data[0].status_score_zero_count || 0) + (_d.data[0].status_score_one_count || 0);
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        getGrade: function () {
            axios.get('/zhaopinapi/exam-assignment/all/score', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {
                    statusScore: this.tabs.queryStatus,
                    name: this.gradeSearch
                }
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.students = _d.data;
                    if (this.tabs.queryStatus === 0 || this.tabs.queryStatus === '0') {
                        this.pendingStudents = _d.data.slice();
                    }
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        fetchPendingStudents: function () {
            return axios.get('/zhaopinapi/exam-assignment/all/score', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: { statusScore: 0, name: '' },
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    this.pendingStudents = data.data || [];
                    return this.pendingStudents;
                }
                return [];
            }).catch(() => []);
        },
        fetchScoredStudents: function () {
            return axios.get('/zhaopinapi/exam-assignment/all/score', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {
                    statusScore: 1,
                    name: this.gradeSearch || '',
                },
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    return data.data || [];
                }
                return [];
            }).catch(() => []);
        },
        downloadImportTemplate: function () {
            this.templateLoading = true;
            this.fetchPendingStudents().then((list) => {
                if (!list.length) {
                    this.$message.warning('当前没有待录入考生，无法生成导入模板');
                    return;
                }
                downloadScoreImportTemplate(list);
                this.$message.success('模板已下载，请在「成绩录入」 sheet 中填写分数');
            }).finally(() => {
                this.templateLoading = false;
            });
        },
        exportScoredExcel: function () {
            this.exportLoading = true;
            this.fetchScoredStudents().then((list) => {
                if (!list.length) {
                    this.$message.warning('当前没有已录入考生可导出');
                    return;
                }
                downloadScoredExport(list);
                this.$message.success(`已导出 ${list.length} 名已录入考生成绩`);
            }).finally(() => {
                this.exportLoading = false;
            });
        },
        triggerImportFile: function () {
            if (this.tabs.curTab !== 0) {
                this.$message.warning('请切换到「待录入」标签后再导入');
                return;
            }
            if (this.$refs.importFileInput) {
                this.$refs.importFileInput.value = '';
                this.$refs.importFileInput.click();
            }
        },
        onImportFileChange: function (event) {
            const file = event.target.files && event.target.files[0];
            if (!file) {
                return;
            }
            Promise.all([readScoreImportFile(file), this.fetchPendingStudents()]).then(([workbook, pendingList]) => {
                const parsed = parseScoreImportWorkbook(workbook, pendingList);
                this.importPreviewList = parsed.previewList;
                this.importPayload = parsed.payload;
                this.importParseErrors = parsed.errors;
                this.importPreviewVisible = true;
            }).catch((error) => {
                this.$message.error('解析 Excel 失败，请使用系统模板');
                console.log(error);
            });
        },
        resetImportPreview: function () {
            this.importPreviewList = [];
            this.importPayload = [];
            this.importParseErrors = [];
            this.importSubmitting = false;
        },
        calcPreviewTotal: function (item) {
            if (!item || !item.scoresList || !item.scoresList.length) {
                return '—';
            }
            return item.scoresList.reduce((sum, subject) => sum + Number(subject.score || 0), 0);
        },
        confirmImport: function () {
            if (!this.importPayload.length || this.importParseErrors.length) {
                return;
            }
            this.importSubmitting = true;
            axios.post('/zhaopinapi/exam-assignment/import/score/batch', this.importPayload, {
                headers: {'Authorization': Cookies.get('reqToKen')},
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    const result = data.data || {};
                    const failCount = result.failCount || 0;
                    const successCount = result.successCount || 0;
                    if (failCount > 0) {
                        const errors = (result.errors || []).join('\n');
                        this.$alert(errors || '部分考生导入失败', '导入结果', { type: 'warning' }).catch(() => {});
                    } else {
                        this.$message.success(`成功导入 ${successCount} 名考生成绩`);
                        this.importPreviewVisible = false;
                    }
                    this.getCounts();
                    this.getGrade();
                } else {
                    this.$message.error((data && data.message) || '导入失败');
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message) || '导入失败';
                this.$message.error(msg);
                console.log(error);
            }).finally(() => {
                this.importSubmitting = false;
            });
        },
        saveScore: function (id,n) {
            let _arr = this.students[n].examScheduleList;
            let _scoreArr = [];
            let _total = 0;
            _arr.forEach(item => {
                _scoreArr.push({examScheduleId: item.id, score: parseFloat(item.score)});
                _total += parseFloat(item.score);
            })
            let scoreObj = {
                examAssignmentId: id,
                totalScore: _total,
                scoresList: _scoreArr
            };
            axios.post('/zhaopinapi/exam-assignment/one/score', scoreObj,{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.$message({
                        message: '恭喜你，分数保存成功！',
                        type: 'success'
                    });
                    this.getCounts();
                    this.getGrade();
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
    }
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .pageManager-m{padding: 30px 0;}
    .manager-rig{}
    .manager-rt{height: 42px; padding-bottom: 18px;}
    .manager-rtle{font-size: 24px; line-height: 40px; float: left; font-weight: bold;}
    .manager-rsubtle{font-size: 12px; line-height: 20px; color: #99A1AF;}
    .manager-rtr{
        height: 40px;
        float: right;
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .manager-rtr-export{margin-left: 12px;}
    .exam-m1{padding: 20px 0;}
    .exam-m1-box{background: #FFF; border: 1px solid #e9e9eb; box-shadow: 0 3px 3px 0 #e9e9eb; padding: 16px; height: 50px; border-radius: 10px; position: relative;}
    .exam-m1-icon{padding: 8px; width: 20px; height: 20px; font-size: 20px; line-height: 20px; text-align: center; border-radius: 8px; margin-top: 7px; position: absolute; right: 20px; top: 15px;}
    .exam-m1-icon-blue{background: #ecf5ff; color: #409eff;}
    .exam-m1-icon-yellow{background: #fdf6ec; color: #e6a23c;}
    .exam-m1-icon-green{background: #f0f9eb; color: #67c23a;}
    .exam-m1-icon-purple{background: #faf5ff; color: #a320f7;}
    .exam-m1-box-tle{font-size: 12px; line-height: 18px; color: #99A1AF;}
    .exam-m1-box-num{font-size: 24px; line-height: 32px; color: #000; font-weight: bold;}
    .blue{color: #409EFF;}
    .red{color: #E7000B;}
    .green{color: #67C23A;}
    .yellow{color: #E6A23C;}

    .exam-m2{background: #FFF; border-radius: 10px; border: 1px solid #e9e9eb; box-shadow: 0 3px 3px 0 #e9e9eb;}
    .exam-m2-t{padding: 16px 24px; border-bottom: 1px solid #D1D5DC;}
    .exam-tab{background: #f3f4f6; padding: 4px; border-radius: 6px; display: inline-block;}
    .exam-tab ul{margin: 0; padding: 0; list-style: none;}
    .exam-tab ul li{padding: 6px 12px; height: 20px; line-height: 20px; border-radius: 6px; display: inline-block; cursor: pointer; color: #6A7282;}
    .exam-tab ul li:hover{background: #eceef1; color: #3E3E3E;}
    .exam-tab ul li.active{background: #FFFFFF; color: #e6a23c; font-weight: bold;}
    .exam-tr{float: right; padding-left: 15px;}

    .manager-exam-table{width: 100%; border-collapse: collapse; border-spacing: 0; border-radius: 10px;}
    .manager-exam-table td{padding: 10px 20px; line-height: 20px !important; background: #fff; border-bottom: 1px solid #e9e9eb;}
    .manager-exam-table th{padding: 15px 20px; line-height: 20px; background: #f9fafb; border-bottom: 1px solid #e9e9eb; text-align: left;}
    .manager-exam-table tr:hover td{background: #f9fafb;}
    .exam-td-name{font-weight: bold; line-height: 20px; color: #3E3E3E; font-size: 14px;}
    .exam-td-icard{line-height: 20px; color: #99A1AF; font-size: 12px;}
    .exam-edit-box{background: #FFF; border: 1px solid #e9e9eb; border-radius: 10px; padding: 16px;}
    .exam-form-t{font-size: 14px; line-height: 20px; padding-bottom: 5px;}
    .exam-form-b{padding-bottom: 16px;}
    .exam-subject{padding: 12px 12px 0 12px; border-radius: 10px; background: #f9fafb; border: 1px solid #D1D5DC; margin-bottom: 5px; position: relative;}
    .exam-subject-li{padding-bottom: 12px;}
    .exam-subject-del{color: #99A1AF; font-size: 16px; width: 16px; float: right; cursor: pointer; margin-top: 5px;}
    .exam-subject-del:hover{color: #E7000B;}
    .exam-edit-action{border-top: 1px solid #e9e9eb; padding-top: 15px; text-align: right;}
    .import-error-box{border: 1px solid #FDE68A; background: #FFFBEB; border-radius: 8px; padding: 12px 16px; max-height: calc(85vh - 160px); overflow: auto;}
    .import-error-title{font-weight: bold; color: #92400E; margin-bottom: 8px;}
    .import-error-box ul{margin: 0; padding-left: 18px; color: #92400E;}
    .import-preview-wrap{display: flex; flex-direction: column; min-height: 420px;}
    .import-preview-summary{display: flex; align-items: center; gap: 8px; margin-bottom: 16px; padding: 12px 16px; border-radius: 10px; background: #EFF6FF; border: 1px solid #DBEAFE; color: #1E3A8A; font-size: 14px;}
    .import-preview-summary-num{font-size: 22px; font-weight: bold; color: #E7000B; line-height: 1;}
    .import-preview-list{max-height: calc(85vh - 220px); overflow: auto; padding-right: 4px;}
    .import-preview-card{border: 1px solid #E5E7EB; border-radius: 12px; background: #FFF; margin-bottom: 16px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.06);}
    .import-preview-card:last-child{margin-bottom: 0;}
    .import-preview-card-head{display: flex; gap: 16px; padding: 16px 18px; background: #F9FAFB; border-bottom: 1px solid #E5E7EB;}
    .import-preview-index{flex: 0 0 32px; height: 32px; line-height: 32px; text-align: center; border-radius: 50%; background: #E7000B; color: #fff; font-weight: bold; font-size: 14px;}
    .import-preview-main{flex: 1; min-width: 0;}
    .import-preview-name-row{display: flex; align-items: center; gap: 10px; flex-wrap: wrap;}
    .import-preview-name{font-size: 18px; font-weight: bold; color: #111827;}
    .import-preview-id{font-size: 12px; color: #6B7280; background: #E5E7EB; border-radius: 4px; padding: 2px 8px;}
    .import-preview-idcard{margin-top: 4px; font-size: 13px; color: #6B7280; font-family: Consolas, monospace;}
    .import-preview-major{margin-top: 6px; font-size: 13px; color: #374151;}
    .import-preview-ticket{margin-top: 4px; font-size: 13px; color: #6B7280;}
    .import-preview-total{flex: 0 0 120px; display: flex; flex-direction: column; gap: 4px; text-align: right;}
    .import-preview-total .label{font-size: 12px; color: #9CA3AF;}
    .import-preview-total .value{font-size: 24px; font-weight: bold; color: #E7000B;}
    .import-preview-subjects{padding: 14px 18px 16px;}
    .import-preview-subjects-title{display: flex; align-items: center; gap: 8px; margin-bottom: 10px; font-size: 14px; font-weight: bold; color: #374151;}
    .import-preview-subject-row{display: flex; align-items: center; gap: 12px; padding: 10px 12px; margin-bottom: 8px; border-radius: 8px; background: #FAFAFA; border: 1px solid #F3F4F6;}
    .import-preview-subject-row:last-child{margin-bottom: 0;}
    .import-subject-index{flex: 0 0 24px; height: 24px; line-height: 24px; text-align: center; border-radius: 6px; background: #FEF2F2; color: #E7000B; font-size: 12px; font-weight: bold;}
    .import-subject-name{flex: 1; font-weight: 600; color: #111827; font-size: 14px;}
    .import-subject-score{flex: 0 0 100px; color: #111827; font-size: 16px; font-weight: bold; text-align: right;}
    .import-subject-score i{margin-right: 4px; color: #9CA3AF; font-weight: normal;}

    /deep/ .import-preview-dialog{max-width: 1280px; margin-top: 4vh !important;}
    /deep/ .import-preview-dialog .el-dialog__body{padding: 16px 24px 8px; max-height: calc(92vh - 130px); overflow: hidden;}
    /deep/ .import-preview-dialog .el-dialog__header{padding: 16px 24px 10px; border-bottom: 1px solid #F3F4F6;}
    /deep/ .import-preview-dialog .el-dialog__title{font-size: 18px; font-weight: bold;}
    /deep/ .import-preview-dialog .el-dialog__footer{padding: 12px 24px 16px; border-top: 1px solid #F3F4F6;}

    /deep/ .el-dialog{border-radius: 12px;}
    /deep/ .el-dialog .el-dialog__header{background: #f9fafb !important; border-top-left-radius: 12px; border-top-right-radius: 12px;}
    /deep/ .el-dialog .el-dialog__footer{background: #f9fafb !important; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; padding: 10px 20px;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
